// extracted by mini-css-extract-plugin
export default {"QuoteInput":"styles_QuoteInput__oInss","input":"styles_input__vX11s"};